import { paginationMiddleware } from "utils/PaginationMiddleWare";
import { apiBase } from "APIs/index";

// For get all notification message
export const AI_getNotification = apiBase.createListInstance({
  endpoint: "/get-all-notification/",
  method: "get",
  reducer: "showNotificationReducer",
  key: "id",
  reduxKey: "NotificationData",
  action: "GET_NOTIFICATION_LIST",
  onSuccess: (data) => data,
  // middleware : paginationMiddleware
});

// For read notification
export const AI_deleteNotification = apiBase.createListInstance({
  endpoint: "/get-all-notification/",
  method: "delete",
  reducer: "showNotificationReducer",
  // key: "id",
  // reduxKey: "NotificationData",
  action: "GET_DELETE_NOTIFICATION_LIST",
  // onSuccess: (data) => data.all_notification,
});


// api/delete-notification
export const AI_delNotification = apiBase.createListInstance({
    endpoint: "/delete-notification/",
    method: "delete",
    reducer: "showNotificationReducer",
    reduxKey: "NotificationData",
    action: "DELETE_NOTIFICATION",
    

    onSuccess: (data) => {
        AI_getNotification.deleteAction(data.deleted_id)
    }

})


export const AI_getAnnouncement = apiBase.createListInstance({
  endpoint: "/get-all-announcement/",
  method: "get",
  reducer: "showNotificationReducer",
  key: "id",
  reduxKey: "AnnouncementData",
  action: "GET_ANNOUNCEMENT_LIST",
  onSuccess: (data) => data,
});

export const AI_deleteAnnouncement = apiBase.createListInstance({
  endpoint: "/read-announcement/",
  method: "put",
  reducer: "showNotificationReducer",
  // key: "id",
  // reduxKey: "NotificationData",
  action: "READ_ANNOUNCEMENT",
  // onSuccess: (data) => data.all_notification,
});
export const AI_addUpdateConfiguration = apiBase.createListInstance({
  endpoint: "/employee-push-notification/{employee_id}",
  method: "post",
  key: "employee_id",
  reducer: "showNotificationReducer",
  action: "ADD_UPDATE_CONFIGURATION",
});
